(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-tab"] && !window.DesignMode) return;
  try {
    
  $('ul.tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');
      $('ul.tabs li').removeClass('current');
      $('.tab-content').removeClass('current');
      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 
  var $jq = jQuery.noConflict();
  $jq(document).ready(function() {
    $jq(".layer-trigger").click(function(){
      console.log('layer trigger');
       $jq(".layer-trigger").removeClass("active");
       $jq(this).addClass("active");
  
       var slideno = $jq(this).data('slide');
       $jq('.inner').slick('slickGoTo', slideno - 1);
       
    });
  });
   

  

  } catch(e) { console.error(e); }
})();
})();
